import { render, staticRenderFns } from "./DeveloperItemDetailsModal.vue?vue&type=template&id=3c51fa9c&"
import script from "./DeveloperItemDetailsModal.vue?vue&type=script&lang=js&"
export * from "./DeveloperItemDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports